/* Reveal-on-scroll. Elements with .reveal fade/slide in when entering the
   viewport; stagger via --i custom property. Fail-safe: content is visible
   unless html.js-reveal is set (added here, after IO is confirmed). */
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('js-reveal');

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  const observeAll = (root) => {
    root.querySelectorAll('.reveal:not(.is-in)').forEach((el) => io.observe(el));
  };

  observeAll(document);
  document.addEventListener('shopify:section:load', (e) => observeAll(e.target));
})();
